import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const UserProfilePage = lazyWithRetry(() =>
  import("@/features/userProfile/pages/UserProfile").then((m) => ({ default: m.UserProfilePage })),
);

export const USER_PROFILE_PATH = "/mon-profil";

export const USER_PROFILE_PROFIL_TAB = `${USER_PROFILE_PATH}?tab=profil`;
export const USER_PROFILE_AUTORISATIONS_TAB = `${USER_PROFILE_PATH}?tab=autorisations`;
export const USER_PROFILE_BENEFICIARIES_TAB = `${USER_PROFILE_PATH}?tab=beneficiaries`;
export const USER_PROFILE_SESSIONS_TAB = `${USER_PROFILE_PATH}?tab=sessions`;

const authRoutes: RouteConfig[] = [
  {
    path: USER_PROFILE_PATH,
    element: <UserProfilePage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default authRoutes;
